import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Theme } from '@interacta-shared/data-access-theme';
import { AppLogoPipe } from '@interacta-shared/util-common';

@Component({
    selector: 'interacta-sidebar-logo',
    templateUrl: './sidebar-logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [AppLogoPipe],
})
export class SidebarLogoComponent {
    readonly currentTheme = input.required<Theme>();
}
